// src/onboarding/aha/ConfettiBurst.jsx
import React, { useEffect, useState } from "react";

export default function ConfettiBurst() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div style={S.wrap}>
      {Array.from({ length: 14 }).map((_, i) => (
        <div key={i} style={{ ...S.piece, ...S[`p${i % 4}`] }} />
      ))}
    </div>
  );
}

const S = {
  wrap: { position: "relative", height: 60 },
  piece: {
    width: 8,
    height: 14,
    position: "absolute",
    top: 10,
    left: "50%",
    borderRadius: 2,
    animation: "fall 1.2s ease forwards",
  },
  p0: { background: "#FF7C24" },
  p1: { background: "#FFD93D" },
  p2: { background: "#2ECC71" },
  p3: { background: "#1FB2F5" },
};